/** Öffentlicher Gutschein-Link. Nie den internen Prüf-Endpunkt als Klickziel verwenden. */
export const buildPublicRedeemUrl = (
  code,
  baseUrl = process.env.REACT_APP_PUBLIC_REDEEM_URL || "https://www.myn.club/r",
) => `${baseUrl.replace(/\/+$/, "")}/${encodeURIComponent(String(code || "").trim())}`;
